import { React, useState } from "react";
import GridTable from "../../../../components/GridTable";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import ClassicParameters from "./components/ClassicParameters";
import PrimaryButton from "../../../../components/PrimaryButton";
import { Link } from "react-router-dom";
import DeepParameters from "./components/DeepParameters";

const tabStyles = makeStyles({
  root: {
    minHeight: "auto",
    minWidth: "auto",
    padding: 5,
    marginRight: 15,
    textTransform: "capitalize",
    fontSize: "1.4rem",
  },
});

const useStyles = makeStyles((theme) => ({
  tab: {
    margin: "20px 0px 5px 3%",
  },
  container: {
    height: "65%",
    marginTop: "2%",
    display: "flex",
    overflow: "scroll",
    color: theme.palette.text.primary,
  },
  tableElement: {
    margin: "4%",
  },
  centeredContainer: {
    marginLeft: "10%",
    marginTop: "10%",
  },
  myButton: {
    float: "right",
    marginRight: "8%",
  },
}));

const Training = (props) => {
  const [value, setValue] = useState(0);
  const tabClass = tabStyles();
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function startTraining() {
    if (props.selectedClassifier === "classic") {
      //image
      const response = await fetch(
        "http://superbioai.com:5000/submit?simple-module=MultiTumorClassifiers"
      );
      const data = await response.json();
      //console.log(data); //data ex: {job-id: "1344463", result: "OK"}
    }
    if (props.selectedClassifier === "deep") {
      //Diabetes (live data)
      const response = await fetch(
        "http://superbioai.com:5000/submit?simple-module=DiabetesClassification"
      );
      const data = await response.json();
      //console.log(data); // data ex: {job-id: "1344463", result: "OK"}
    }
  }

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="Overview" />
      </Tabs>

      <div className={classes.container}>
        <div style={{ width: "50%" }}>
          <div className={classes.centeredContainer}>
            <div className={classes.tableElement}>
              <GridTable
                tableContent={[
                  {
                    key: <span style={{ fontWeight: "bold" }}>Dataset:</span>,
                    value: `${sessionStorage.getItem("dataset")}`,
                  },
                ]}
                keySize={5}
                valueSize={6}
              />
            </div>
            <div className={classes.tableElement}>
              <GridTable
                tableContent={[
                  {
                    key: <span style={{ fontWeight: "bold" }}>Model:</span>,
                    value:
                      props.selectedClassifier === "classic"
                        ? JSON.parse(sessionStorage.getItem("models")).map(
                            (item, index) => {
                              return <div key={index}>{item}</div>;
                            }
                          )
                        : JSON.parse(sessionStorage.getItem("models")).map(
                            (item, index) => {
                              return (
                                <div key={index}>
                                  {item.map((model, index) => {
                                    if (index === 0) {
                                      return model;
                                    } else {
                                      return ` + ${model}`;
                                    }
                                  })}
                                </div>
                              );
                            }
                          ),
                  },
                ]}
                keySize={5}
                valueSize={6}
              />
            </div>

            <div className={classes.tableElement}>
              <GridTable
                tableContent={[
                  {
                    key: (
                      <span style={{ fontWeight: "bold" }}>
                        Estimated run time:
                      </span>
                    ),
                    value: "25 minutes",
                  },
                ]}
                keySize={5}
                valueSize={6}
              />
            </div>
            <div className={classes.tableElement}>
              <GridTable
                tableContent={[
                  {
                    key: (
                      <span style={{ fontWeight: "bold" }}>
                        Estimated CPU usage:
                      </span>
                    ),
                    value: "25 MB/s",
                  },
                ]}
                keySize={5}
                valueSize={6}
              />
            </div>
            <div className={classes.tableElement}>
              <GridTable
                tableContent={[
                  {
                    key: (
                      <span style={{ fontWeight: "bold" }}>Live Analysis:</span>
                    ),
                    value: "On",
                  },
                ]}
                keySize={5}
                valueSize={6}
              />
            </div>
          </div>
        </div>
        <div style={{ width: "50%" }}>
          {props.selectedClassifier === "classic" ? (
            <ClassicParameters />
          ) : (
            <DeepParameters />
          )}
        </div>
      </div>

      <Link to="/methods/new-method/results">
        <PrimaryButton
          innerText="TRAIN"
          styleClasses={classes.myButton}
          onClick={startTraining}
        />
      </Link>
    </>
  );
};

export default Training;
